var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state.model.creditor && _vm.state.model.creditor.id === _vm.AIRA_ID)?_c('uploadFile-button',{staticClass:"d-inline-block",attrs:{"icon":"cloud_upload","text":"Upload Transaction","accept":"excel","disabled":_vm.loading,"multiple":false},on:{"changedFile":_vm.handleFile}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }